import type { JSX } from 'react';
import { useContent } from '@data';
import { useT } from '@/i18n';
import { SectionHeader, RevealWrapper, Tag } from '@components/ui';
import './Projects.css';

export default function Projects(): JSX.Element {
  const { PROJECTS } = useContent();
  const t = useT();

  return (
    <section id="projets" className="section Projects">
      <SectionHeader
        chip={t.sections.projects.chip}
        chipVariant="ci"
        title={t.sections.projects.title}
        subtitle={t.sections.projects.subtitle}
      />

      <div className="Projects__grid">
        {PROJECTS.map((project, i) => (
          <RevealWrapper key={project.id} delay={(i % 4) + 1}>
            <article
              className="ProjectCard"
              style={{
                '--project-color': project.accentColorVar,
              } as React.CSSProperties}
              aria-labelledby={`project-${project.id}`}
            >
              <div className="ProjectCard__accent" aria-hidden="true" />
              <div className="ProjectCard__header">
                {project.logoSrc && (
                  <img
                    className="ProjectCard__logo"
                    src={project.logoSrc}
                    alt=""
                    width={40}
                    height={40}
                    loading="lazy"
                  />
                )}
                <h3 className="ProjectCard__name" id={`project-${project.id}`}>
                  {project.name}
                </h3>
              </div>
              <p className="ProjectCard__desc">{project.description}</p>
              <div className="ProjectCard__tags" role="list" aria-label="Technologies">
                {project.tags.map(tag => (
                  <Tag key={tag}>{tag}</Tag>
                ))}
              </div>
              {project.link && (
                <a
                  className="ProjectCard__link"
                  href={project.link}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {t.sections.projects.visit} →
                </a>
              )}
            </article>
          </RevealWrapper>
        ))}
      </div>
    </section>
  );
}
